// pages/UserManagementFormPage.jsx

import React from "react";
import UserManagementForm from "../components/UserManagementForm";

function UserManagementFormPage() {
  return (
    <div>
      <UserManagementForm />
    </div>
  );
}

export default UserManagementFormPage;
